import React from 'react';

import { Container } from './styles';

const FormGroup: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default FormGroup;
